import "./SafetyTrustBanner.css";

const SAFETY_BADGES = [{ icon: "nema", label: "NCID Identity Verified" }];

function SafetyIcon({ name, className = "" }) {
  const common = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  switch (name) {
    case "shield":
      return (
        <svg {...common} className={className}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      );
    case "background":
      return (
        <svg {...common} className={className}>
          <circle cx="10" cy="8" r="3.5" />
          <path d="M4 20v-1.5a6 6 0 0112 0V20" />
          <circle cx="18" cy="9" r="2.5" />
          <path d="M18 14v6" />
        </svg>
      );
    case "medical":
      return (
        <svg {...common} className={className}>
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M9 7V6a3 3 0 016 0v1" />
          <path d="M12 12v4M10 14h4" />
        </svg>
      );
    case "nema":
      return (
        <svg {...common} className={className}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
    default:
      return null;
  }
}

function GreenCheck() {
  return (
    <svg className="safety-trust__check" viewBox="0 0 20 20" fill="none" aria-hidden>
      <circle cx="10" cy="10" r="10" fill="#22c55e" />
      <path d="M6.2 10.3 8.6 12.7 14 7.3" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function SafetyTrustBanner() {
  return (
    <div className="safety-trust">
      <div className="safety-trust__main">
        <span className="safety-trust__shield" aria-hidden>
          <svg viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#22c55e" />
            <path d="M24 10s10 4 10 10v6c0 7-10 12-10 12S14 33 14 26v-6c0-6 10-10 10-10z" fill="#fff" />
            <path d="m18 25 4 4 8-8" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <div>
          <h3 className="safety-trust__title">Know Who You&apos;re Considering for Care</h3>
          <p className="safety-trust__desc">
            Review NCID identity-verification information on care professional profiles before
            making a hiring decision.
          </p>
        </div>
      </div>
      <div className="safety-trust__badges">
        {SAFETY_BADGES.map((item) => (
          <div key={item.label} className="safety-trust__badge">
            <span className="safety-trust__badge-icon">
              <SafetyIcon name={item.icon} />
            </span>
            <GreenCheck />
            <span className="safety-trust__badge-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
